import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../data/mock";
import { Reveal } from "./ui/Reveal";

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  if (!testimonials || testimonials.length === 0) return null;

  const current = testimonials[index] || testimonials[0];

  const prev = () => setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIndex((i) => (i + 1) % testimonials.length);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center">
          <Reveal>
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-2xl bg-neutral-100 p-6 h-[280px] flex flex-col justify-between">
                <div className="text-neutral-950 text-[36px] font-semibold leading-none tracking-tight">
                  {current.stat}
                </div>
                <div className="text-neutral-700 text-lg font-medium">{current.statLabel}</div>
              </div>
              <div className="rounded-2xl overflow-hidden h-[280px] bg-neutral-200">
                {current.photo ? (
                  <img
                    src={current.photo}
                    alt={current.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-neutral-500 font-semibold text-2xl">
                    {current.initials}
                  </div>
                )}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <span className="inline-block text-[11px] tracking-[0.18em] uppercase text-neutral-500 border border-black/10 rounded-full px-3 py-1.5">
              Testimonials
            </span>
            <blockquote className="mt-6 text-[22px] sm:text-[28px] leading-[1.35] tracking-tight text-neutral-950 font-medium">
              &ldquo;{current.quote}&rdquo;
            </blockquote>
            <div className="mt-6">
              <div className="text-neutral-950 font-semibold">{current.name}</div>
              <div className="text-sm text-neutral-500">{current.role}</div>
            </div>
          </Reveal>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            onClick={prev}
            aria-label="Previous testimonial"
            className="w-11 h-11 rounded-full border border-black/10 flex items-center justify-center hover:bg-neutral-50 transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button
            onClick={next}
            aria-label="Next testimonial"
            className="w-11 h-11 rounded-full bg-black text-white flex items-center justify-center hover:opacity-90 transition-opacity"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
